/* bacter-hoteleria.js
   Calculadora de dosis para sector hotelero (BACTER spp.)

   Escenario base (posada / hotel pequeño):
   - 20 habitaciones
   - 70 % de ocupación
   - 2 huéspedes/ habitación
   - 12,000 L/día de caudal total
   - 400 mg/L DBO, 800 mg/L DQO
   - Sin PTAR
   - Puntos de aplicación:
        2 baños públicos en lobby
        1 baño público en zona de alberca / playa
        2 baños y vestidores de staff
        2 duchas exteriores en alberca / playa
        2 regaderas en gimnasio / spa
        1 drenaje de piscina / jacuzzi
        2 drenajes en cocina principal
        1 trampa de grasa de cocina
        1 drenaje en buffet / snack
        1 drenaje en lavaloza
        1 drenaje en lavandería interna
        1 drenaje en cuartos de basura / compactadora
        1 drenaje en planta de A/C
        1 registro principal antes de fosa / PTAR
        0 otros drenajes especiales

   → 500 g/mes en carga BAJA, modo mantenimiento.
   → Solución madre: ahora se prepara con EL DOBLE de agua (g/30).
*/

(function () {
  'use strict';

  // -------------------------
  //  CONSTANTES DE REFERENCIA
  // -------------------------

  var BASE_HABITACIONES   = 20;
  var BASE_OCUPACION_PCT  = 70;
  var BASE_HUESPEDES_HAB  = 2;
  var BASE_CAUDAL_L_DIA   = 12000;
  var BASE_DBO            = 400;
  var BASE_DQO            = 800;

  // Carga baja = 500 g/mes para el escenario base
  var BASE_G_BAJA = 500;

  // Multiplicadores por carga
  var CARGA_MULT = {
    baja: 1.0,
    media: 1.35,
    alta: 1.7
  };

  // Multiplicadores por modo
  var MODO_MULT = {
    mantenimiento: 1.0,
    choque: 1.7
  };

  // Multiplicadores por tipo de hotel
  var TIPO_MULT = {
    hostal_posada: 1.0,          // base
    motel: 1.1,
    hotel_urbano: 1.2,
    resort: 1.35,
    all_inclusive: 1.45
  };

  // -------------------------
  //  UTILIDADES DOM
  // -------------------------

  function qsa(selector, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(selector));
  }

  function el(tag, attrs) {
    var e = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        e.setAttribute(k, attrs[k]);
      });
    }
    return e;
  }

  // -------------------------
  //  RENDER DEL WIDGET
  // -------------------------

  function renderWidget(container, cfg) {
    container.innerHTML = '';

    var title = cfg.title || 'Calculadora BACTER spp. – Hotelería y Resorts';

    var h = el('div');
    h.className = 'bacter-title';
    h.style.fontWeight = '800';
    h.style.marginBottom = '8px';
    h.style.fontSize = '24px';
    h.style.textAlign = 'center';
    h.innerText = title;
    container.appendChild(h);

    var form = el('div');
    form.style.display = 'flex';
    form.style.flexWrap = 'wrap';
    form.style.gap = '8px';
    form.style.marginBottom = '10px';

    function labeledNumber(id, label, value, extraCfg) {
      var wrap = el('label');
      wrap.style.flex = '1 1 220px';
      wrap.style.fontSize = '13px';
      wrap.style.display = 'block';

      var lbl = el('div');
      lbl.style.fontWeight = '600';
      lbl.style.marginBottom = '6px';
      lbl.style.whiteSpace = 'pre-line';
      lbl.innerText = label;

      var input = el('input');
      input.type = 'number';
      input.value = value !== undefined ? value : 0;
      input.min = 0;
      input.style.width = '100%';
      input.style.padding = '8px';
      input.style.border = '1px solid #dcdcdc';
      input.style.borderRadius = '6px';
      input.setAttribute('data-role', id);

      if (extraCfg && extraCfg.step) {
        input.step = extraCfg.step;
      }

      wrap.appendChild(lbl);
      wrap.appendChild(input);
      return wrap;
    }

    // Tipo de hotel
    var tipoDiv = el('div');
    tipoDiv.style.flex = '1 1 240px';
    var tipoLbl = el('div');
    tipoLbl.style.fontWeight = '600';
    tipoLbl.style.marginBottom = '6px';
    tipoLbl.innerText = 'Tipo de hotel\nSelecciona un giro';
    var selTipo = el('select');
    selTipo.setAttribute('data-role', 'tipo_hotel');
    selTipo.style.padding = '8px';
    selTipo.style.border = '1px solid #dcdcdc';
    selTipo.style.borderRadius = '6px';

    function addTipo(value, text) {
      var o = el('option');
      o.value = value;
      o.innerText = text;
      selTipo.appendChild(o);
    }

    addTipo('hostal_posada', 'Posada, hostal o hotel pequeño');
    addTipo('motel', 'Motel / auto-hotel');
    addTipo('hotel_urbano', 'Hotel urbano / de ciudad');
    addTipo('resort', 'Resort de playa');
    addTipo('all_inclusive', 'Resort todo incluido');

    selTipo.value = cfg.defaults.tipo_hotel || 'hostal_posada';

    tipoDiv.appendChild(tipoLbl);
    tipoDiv.appendChild(selTipo);
    form.appendChild(tipoDiv);

    // Programa de aplicación
    var progDiv = el('div');
    progDiv.style.flex = '1 1 220px';
    var progLbl = el('div');
    progLbl.style.fontWeight = '600';
    progLbl.style.marginBottom = '6px';
    progLbl.innerText = 'Programa de aplicación\nSelecciona la frecuencia';
    var selProg = el('select');
    selProg.setAttribute('data-role', 'programa');
    selProg.style.padding = '8px';
    selProg.style.border = '1px solid #dcdcdc';
    selProg.style.borderRadius = '6px';

    function addProg(value, text) {
      var o = el('option');
      o.value = value;
      o.innerText = text;
      selProg.appendChild(o);
    }

    addProg('semanal',   'Semanal (4 aplicaciones/mes)');
    addProg('diaria',    'Diaria (30 aplicaciones/mes)');
    addProg('quincenal', 'Quincenal (2 aplicaciones/mes)');
    addProg('mensual',   'Mensual (1 aplicación/mes)');
    selProg.value = cfg.defaults.programa || 'semanal';

    progDiv.appendChild(progLbl);
    progDiv.appendChild(selProg);
    form.appendChild(progDiv);

    // Nº de habitaciones
    form.appendChild(
      labeledNumber(
        'num_habitaciones',
        'Nº de habitaciones\ntotal en el hotel',
        cfg.defaults.num_habitaciones || BASE_HABITACIONES
      )
    );

    // Ocupación promedio
    form.appendChild(
      labeledNumber(
        'ocupacion_pct',
        '% ocupación promedio\n(% habitaciones ocupadas)',
        cfg.defaults.ocupacion_pct || BASE_OCUPACION_PCT,
        { step: '1' }
      )
    );

    // Huéspedes por habitación (solo enteros)
    form.appendChild(
      labeledNumber(
        'huespedes_por_hab',
        'Huéspedes promedio por\nhabitación ocupada',
        cfg.defaults.huespedes_por_hab || BASE_HUESPEDES_HAB,
        { step: '1' }
      )
    );

    // Caudal promedio total
    form.appendChild(
      labeledNumber(
        'caudal_litros_dia',
        'Caudal promedio total\n(L/día) opcional',
        cfg.defaults.caudal_litros_dia || BASE_CAUDAL_L_DIA,
        { step: '1' }
      )
    );

    // DBO / DQO
    form.appendChild(
      labeledNumber(
        'dbo_inicial',
        'DBO inicial aproximada\n(mg/L) opcional',
        cfg.defaults.dbo_inicial || BASE_DBO,
        { step: '1' }
      )
    );
    form.appendChild(
      labeledNumber(
        'dqo_inicial',
        'DQO inicial aproximada\n(mg/L) opcional',
        cfg.defaults.dqo_inicial || BASE_DQO,
        { step: '1' }
      )
    );


    // --- Puntos de aplicación ---

    form.appendChild(
      labeledNumber(
        'banos_publicos_lobby',
        'Nº de baños públicos en lobby\n/ áreas comunes',
        cfg.defaults.banos_publicos_lobby || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'banos_publicos_alberca',
        'Nº de baños públicos en zona de\nalberca / playa',
        cfg.defaults.banos_publicos_alberca || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'banos_staff',
        'Nº de baños y vestidores\nde staff / personal',
        cfg.defaults.banos_staff || 0
      )
    );

    form.appendChild(
      labeledNumber(
        'duchas_alberca_playa',
        'Nº de duchas exteriores en\nalberca / playa',
        cfg.defaults.duchas_alberca_playa || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'regaderas_gym_spa',
        'Nº de regaderas en gimnasio /\ncanchas / spa',
        cfg.defaults.regaderas_gym_spa || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'drenajes_piscinas_jacuzzis',
        'Nº de drenajes de piscinas,\njacuzzis y espejos de agua',
        cfg.defaults.drenajes_piscinas_jacuzzis || 0
      )
    );

    form.appendChild(
      labeledNumber(
        'drenajes_cocina_principal',
        'Nº de drenajes en cocina\n(canales, coladeras, registros)',
        cfg.defaults.drenajes_cocina_principal || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'trampas_grasa_cocina',
        'Nº de trampas de grasa\nde cocina y snacks',
        cfg.defaults.trampas_grasa_cocina || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'drenajes_buffet_snack',
        'Nº de drenajes en buffet, snack\nbar y bares húmedos',
        cfg.defaults.drenajes_buffet_snack || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'drenajes_lavaloza',
        'Nº de drenajes en lavaloza /\náreas de lavado de loza',
        cfg.defaults.drenajes_lavaloza || 0
      )
    );

    form.appendChild(
      labeledNumber(
        'drenajes_lavanderia',
        'Nº de drenajes en lavandería\ninterna',
        cfg.defaults.drenajes_lavanderia || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'drenajes_cuartos_basura',
        'Nº de drenajes en cuartos de\nbasura / compactadoras',
        cfg.defaults.drenajes_cuartos_basura || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'drenajes_planta_ac',
        'Nº de drenajes en cuartos de\nmáquinas / aire acondicionado',
        cfg.defaults.drenajes_planta_ac || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'registros_principales',
        'Nº de registros principales antes\nde fosa o PTAR',
        cfg.defaults.registros_principales || 0
      )
    );
    form.appendChild(
      labeledNumber(
        'otros_drenajes',
        'Nº de otros drenajes especiales\n(lab, áreas técnicas, etc.)',
        cfg.defaults.otros_drenajes || 0
      )
    );

    // Carga orgánica
    var cargaDiv = el('div');
    cargaDiv.style.flex = '1 1 260px';
    var cargaLbl = el('div');
    cargaLbl.style.fontWeight = '600';
    cargaLbl.style.marginBottom = '6px';
    cargaLbl.innerText = 'Carga orgánica\ngeneral del sistema';
    var selCarga = el('select');
    selCarga.setAttribute('data-role', 'carga');
    selCarga.style.padding = '8px';
    selCarga.style.border = '1px solid #dcdcdc';
    selCarga.style.borderRadius = '6px';

    ['baja', 'media', 'alta'].forEach(function (v) {
      var o = el('option');
      o.value = v;
      o.innerText =
        v === 'baja'
          ? 'Baja (hotel pequeño, poco uso de cocina y lavandería)'
          : v === 'media'
          ? 'Media (hotel con ocupación estable y servicios activos)'
          : 'Alta (resort, mucho buffet, lavandería y albercas todo el día)';
      if (v === cfg.defaults.carga) o.selected = true;
      selCarga.appendChild(o);
    });

    cargaDiv.appendChild(cargaLbl);
    cargaDiv.appendChild(selCarga);
    form.appendChild(cargaDiv);

    // Modo
    var modoDiv = el('div');
    modoDiv.style.flex = '1 1 260px';
    var modoLbl = el('div');
    modoLbl.style.fontWeight = '600';
    modoLbl.style.marginBottom = '6px';
    modoLbl.innerText = 'Modo de aplicación\n(tipo de solución)';
    var selModo = el('select');
    selModo.setAttribute('data-role', 'modo');
    selModo.style.padding = '8px';
    selModo.style.border = '1px solid #dcdcdc';
    selModo.style.borderRadius = '6px';

    ['mantenimiento', 'choque'].forEach(function (v) {
      var o = el('option');
      o.value = v;
      o.innerText =
        v === 'mantenimiento'
          ? 'Mantenimiento (uso regular, sistema estable)'
          : 'Choque (problema fuerte de olores, grasas o taponamientos)';
      if (v === cfg.defaults.modo) o.selected = true;
      selModo.appendChild(o);
    });

    modoDiv.appendChild(modoLbl);
    modoDiv.appendChild(selModo);
    form.appendChild(modoDiv);




    // --- PTAR: columna 1 = ¿hay PTAR? ---
    var ptarChkWrap = el('div');
    ptarChkWrap.style.flex = '1 1 260px';
    ptarChkWrap.style.fontSize = '13px';

    var ptarLbl = el('div');
    ptarLbl.style.fontWeight = '600';
    ptarLbl.style.marginBottom = '6px';
    ptarLbl.innerText = '¿El hotel cuenta con\nplanta de tratamiento (PTAR)?';
    ptarChkWrap.appendChild(ptarLbl);

    var ptarRow = el('div');
    ptarRow.style.display = 'flex';
    ptarRow.style.alignItems = 'center';
    ptarRow.style.gap = '8px';

    var ptarChk = el('input');
    ptarChk.type = 'checkbox';
    ptarChk.setAttribute('data-role', 'tiene_ptar');
    ptarChk.checked = !!cfg.defaults.tiene_ptar;

    var ptarChkLbl = el('label');
    ptarChkLbl.style.cursor = 'pointer';
    ptarChkLbl.style.whiteSpace = 'nowrap';
    ptarChkLbl.innerText = 'Sí, hay PTAR en el sitio';

    ptarRow.appendChild(ptarChk);
    ptarRow.appendChild(ptarChkLbl);
    ptarChkWrap.appendChild(ptarRow);

    form.appendChild(ptarChkWrap);

    // --- PTAR: columna 2 = caudal hacia PTAR ---
    var ptarCaudalWrap = labeledNumber(
      'caudal_ptar_m3_dia',
      'Caudal medio que llega a la PTAR\n(m³/día) opcional',
      cfg.defaults.caudal_ptar_m3_dia || 0,
      { step: '0.1' }
    );
    // que se comporte como una columna más del grid
    ptarCaudalWrap.style.flex = '1 1 260px';
    form.appendChild(ptarCaudalWrap);



    // Químicos fuertes
    var qDiv = el('div');
    qDiv.style.flex = '1 1 260px';
    qDiv.style.display = 'flex';
    qDiv.style.alignItems = 'flex-end';
    var chkQ = el('input');
    chkQ.type = 'checkbox';
    chkQ.setAttribute('data-role', 'quimicos');
    chkQ.checked = !!cfg.defaults.quimicos;
    var chkLbl = el('label');
    chkLbl.style.marginLeft = '10px';
    chkLbl.style.fontSize = '13px';
    chkLbl.innerText =
      '¿Se usan con frecuencia sosa cáustica, cloro o desengrasantes fuertes en drenajes?';
    qDiv.appendChild(chkQ);
    qDiv.appendChild(chkLbl);
    form.appendChild(qDiv);

    container.appendChild(form);



    // Resultado
    var res = el('div');
    res.setAttribute('data-role', 'resultado');
    res.style.marginTop = '12px';
    res.style.padding = '12px';
    res.style.background = '#f8f9fa';
    res.style.borderRadius = '6px';
    res.style.display = 'none';
    container.appendChild(res);

    // Eventos
    qsa('input[type="number"]', container).forEach(function (inp) {
      inp.addEventListener('input', function () {
        doCalc(container, cfg);
      });
    });
    qsa('select', container).forEach(function (sel) {
      sel.addEventListener('change', function () {
        doCalc(container, cfg);
      });
    });
    ['quimicos', 'tiene_ptar'].forEach(function (role) {
      var n = container.querySelector('[data-role="' + role + '"]');
      if (n) n.addEventListener('change', function () {
        doCalc(container, cfg);
      });
    });

    doCalc(container, cfg);
  }

  // -------------------------
  //  LÓGICA DE CÁLCULO
  // -------------------------

  function doCalc(container, cfg) {
    function getVal(role, asNum) {
      var node = container.querySelector('[data-role="' + role + '"]');
      if (!node) return asNum ? 0 : '';
      if (node.type === 'checkbox') return node.checked;
      var v = node.value;
      if (asNum) return parseFloat(v || 0) || 0;
      return v || '';
    }

    function formatGrKg(g) {
      if (!g || g <= 0) return '0 g';
      if (g >= 1000) {
        var kg = g / 1000;
        var txt = kg.toFixed(2).replace(/\.00$/, '');
        return txt + ' kg';
      }
      return Math.round(g) + ' g';
    }

    function formatMl(ml) {
      if (!ml || ml <= 0) return '';
      if (ml < 1000) {
        return Math.round(ml) + ' mL';
      } else {
        var l = ml / 1000;
        var txt = l.toFixed(1).replace(/\.0$/, '');
        return txt + ' L';
      }
    }

    function calcPorPunto(gAplic, mlAplic, nPuntos) {
      if (!nPuntos || nPuntos <= 0 || gAplic <= 0)
        return { g: 0, ml: 0 };
      var gP = gAplic / nPuntos;
      var mlP = mlAplic / nPuntos;
      return {
        g: Math.round(gP * 10) / 10,
        ml: Math.round(mlP / 10) * 10
      };
    }

    var tipoHotel = getVal('tipo_hotel') || cfg.defaults.tipo_hotel || 'hostal_posada';
    var programa  = getVal('programa')   || cfg.defaults.programa   || 'semanal';
    var carga     = getVal('carga')      || cfg.defaults.carga      || 'baja';
    var modo      = getVal('modo')       || cfg.defaults.modo       || 'mantenimiento';
    var quimicos  = !!getVal('quimicos');
    var tienePtar = !!getVal('tiene_ptar');

    var numHab = getVal('num_habitaciones', true);
    if (numHab < 0) numHab = 0;

    var ocupacionPct = getVal('ocupacion_pct', true);
    if (ocupacionPct < 0) ocupacionPct = 0;
    if (ocupacionPct > 100) {
      ocupacionPct = 100;
      var inpOcup = container.querySelector('[data-role="ocupacion_pct"]');
      if (inpOcup) inpOcup.value = 100;
    }

    var huespHab = getVal('huespedes_por_hab', true);
    if (huespHab < 1) huespHab = 1;
    huespHab = Math.round(huespHab);
    var inpH = container.querySelector('[data-role="huespedes_por_hab"]');
    if (inpH) inpH.value = huespHab;

    var caudalDia = getVal('caudal_litros_dia', true);
    var dbo = getVal('dbo_inicial', true);
    var dqo = getVal('dqo_inicial', true);
    var caudalPtarM3 = getVal('caudal_ptar_m3_dia', true);

    // Puntos de aplicación
    var banosLobby    = getVal('banos_publicos_lobby', true);
    var banosAlberca  = getVal('banos_publicos_alberca', true);
    var banosStaff    = getVal('banos_staff', true);
    var duchasAlb     = getVal('duchas_alberca_playa', true);
    var regGym        = getVal('regaderas_gym_spa', true);
    var drPiscinas    = getVal('drenajes_piscinas_jacuzzis', true);
    var drCocina      = getVal('drenajes_cocina_principal', true);
    var trampasCocina = getVal('trampas_grasa_cocina', true);
    var drBuffet      = getVal('drenajes_buffet_snack', true);
    var drLavaloza    = getVal('drenajes_lavaloza', true);
    var drLavanderia  = getVal('drenajes_lavanderia', true);
    var drBasura      = getVal('drenajes_cuartos_basura', true);
    var drPlantaAC    = getVal('drenajes_planta_ac', true);
    var regPrinc      = getVal('registros_principales', true);
    var otrosDr       = getVal('otros_drenajes', true);

    // Si el usuario puso todo en cero y hay habitaciones, asumimos solo habitaciones
    var sumaPuntos =
      banosLobby + banosAlberca + banosStaff + duchasAlb + regGym +
      drPiscinas + drCocina + trampasCocina + drBuffet + drLavaloza +
      drLavanderia + drBasura + drPlantaAC + regPrinc + otrosDr;
    if (sumaPuntos === 0 && numHab > 0) {
      // ok, solo habitaciones
    }

    // -------------------------
    //  PUNTOS EQUIVALENTES
    // -------------------------

    var puntosHab = numHab * 1.0;

    var puntosLobby   = banosLobby * 1.3;
    var puntosAlb     = banosAlberca * 1.3;
    var puntosStaff   = banosStaff * 1.2;
    var puntosDuchAlb = duchasAlb * 1.2;
    var puntosGym     = regGym * 1.2;
    var puntosPisc    = drPiscinas * 1.8;
    var puntosCocina  = drCocina * 2.2;
    var puntosTrampas = trampasCocina * 3.0;
    var puntosBuffet  = drBuffet * 1.8;
    var puntosLavaloza= drLavaloza * 2.2;
    var puntosLavand  = drLavanderia * 2.0;
    var puntosBasura  = drBasura * 2.0;
    var puntosAC      = drPlantaAC * 1.2;
    var puntosReg     = regPrinc * 2.5;
    var puntosOtros   = otrosDr * 1.2;

    var puntosEq =
      puntosHab +
      puntosLobby +
      puntosAlb +
      puntosStaff +
      puntosDuchAlb +
      puntosGym +
      puntosPisc +
      puntosCocina +
      puntosTrampas +
      puntosBuffet +
      puntosLavaloza +
      puntosLavand +
      puntosBasura +
      puntosAC +
      puntosReg +
      puntosOtros;

    // Puntos equivalentes del escenario base
    var BASE_PUNTOS_EQ = (function() {
      var bHab = BASE_HABITACIONES;
      var bLobby = 2;
      var bAlb = 1;
      var bStaff = 2;
      var bDuchAlb = 2;
      var bGym = 2;
      var bPisc = 1;
      var bCocina = 2;
      var bTrampa = 1;
      var bBuffet = 1;
      var bLavaloza = 1;
      var bLavanderia = 1;
      var bBasura = 1;
      var bAC = 1;
      var bReg = 1;
      var bOtros = 0;

      return (
        bHab * 1.0 +
        bLobby * 1.3 +
        bAlb * 1.3 +
        bStaff * 1.2 +
        bDuchAlb * 1.2 +
        bGym * 1.2 +
        bPisc * 1.8 +
        bCocina * 2.2 +
        bTrampa * 3.0 +
        bBuffet * 1.8 +
        bLavaloza * 2.2 +
        bLavanderia * 2.0 +
        bBasura * 2.0 +
        bAC * 1.2 +
        bReg * 2.5 +
        bOtros * 1.2
      );
    })();

    if (puntosEq <= 0) {
      puntosEq = BASE_PUNTOS_EQ || 1;
    }

    var gPorPuntoEq = BASE_G_BAJA / BASE_PUNTOS_EQ;

    var baseMensual = puntosEq * gPorPuntoEq;

    // -------------------------
    //  MULTIPLICADORES
    // -------------------------

    var multTipo = TIPO_MULT[tipoHotel] || 1.0;

    var multOcup = 1.0;
    if (ocupacionPct > 0) {
      var ratioOcc = ocupacionPct / BASE_OCUPACION_PCT;
      if (ratioOcc < 0.5) ratioOcc = 0.5;
      if (ratioOcc > 1.6) ratioOcc = 1.6;
      multOcup = ratioOcc;
    }

    var multHuesp = 1.0;
    if (huespHab > 0) {
      var ratioHuesp = huespHab / BASE_HUESPEDES_HAB;
      if (ratioHuesp < 0.7) ratioHuesp = 0.7;
      if (ratioHuesp > 1.6) ratioHuesp = 1.6;
      multHuesp = ratioHuesp;
    }

    var multCaudal = 1.0;
    if (caudalDia > 0) {
      var ratioCaudal = caudalDia / BASE_CAUDAL_L_DIA;
      if (ratioCaudal < 0.5) ratioCaudal = 0.5;
      if (ratioCaudal > 2.0) ratioCaudal = 2.0;
      multCaudal = ratioCaudal;
    }

    var multDboDqo = 1.0;
    if (dbo > 0 || dqo > 0) {
      var rDbo = dbo > 0 ? dbo / BASE_DBO : 1.0;
      var rDqo = dqo > 0 ? dqo / BASE_DQO : 1.0;
      var rMax = Math.max(rDbo, rDqo);
      if (rMax < 0.7) rMax = 0.7;
      if (rMax > 1.8) rMax = 1.8;
      multDboDqo = rMax;
    }

    var multPtar = 1.0;
    if (tienePtar) {
      var basePtarCaudal = BASE_CAUDAL_L_DIA / 1000; // ~12 m³/día
      var ratioPtar = caudalPtarM3 > 0 ? caudalPtarM3 / basePtarCaudal : 1.0;
      if (ratioPtar < 0.7) ratioPtar = 0.7;
      if (ratioPtar > 2.0) ratioPtar = 2.0;
      multPtar = 1.0 + 0.15 * ratioPtar;
    }

    var multCarga = CARGA_MULT[carga] || 1.0;
    var multModo  = MODO_MULT[modo]   || 1.0;
    var multQuim  = quimicos ? 1.25 : 1.0;

    // Multiplicador total
    var multTotal =
      multTipo *
      multOcup *
      multHuesp *
      multCaudal *
      multDboDqo *
      multPtar *
      multCarga *
      multModo *
      multQuim;

    var ajustado = baseMensual * multTotal;

    // Mínimo absoluto en carga baja: 500 g/mes
    if (ajustado < BASE_G_BAJA && carga === 'baja') {
      ajustado = BASE_G_BAJA;
    }

    ajustado = Math.round(ajustado);

    // -------------------------
    //  APLICACIONES POR MES
    // -------------------------

    var appsMes = 4;
    var labelPrograma = 'semanal';

    if (programa === 'diaria') {
      appsMes = 30;
      labelPrograma = 'diaria';
    } else if (programa === 'quincenal') {
      appsMes = 2;
      labelPrograma = 'quincenal';
    } else if (programa === 'mensual') {
      appsMes = 1;
      labelPrograma = 'mensual';
    }

    var gPorAplicacion = ajustado / appsMes;

    // Volumen de solución madre por aplicación
    // ANTES: gPorAplicacion / 60  → la duplicamos: gPorAplicacion / 30
    var litrosSolAplic = gPorAplicacion > 0 ? gPorAplicacion / 30 : 0;
    if (litrosSolAplic < 0.5 && gPorAplicacion > 0) litrosSolAplic = 0.5;

    if (litrosSolAplic > 0) {
      var steps = litrosSolAplic / 0.5;
      var low = Math.floor(steps) * 0.5;
      var high = Math.ceil(steps) * 0.5;
      var distLow = Math.abs(litrosSolAplic - low);
      var distHigh = Math.abs(litrosSolAplic - high);
      litrosSolAplic = distHigh < distLow ? high : low;
      if (litrosSolAplic <= 0) litrosSolAplic = 0.5;
    }

    var totalMlSolAplic = litrosSolAplic * 1000;

    function mlZona(gZonaAplic) {
      if (gPorAplicacion <= 0 || totalMlSolAplic <= 0) return 0;
      return Math.round((totalMlSolAplic * gZonaAplic) / gPorAplicacion);
    }

    // -------------------------
    //  REPARTO POR ZONAS
    // -------------------------

    var gHabTotal = 0,
      gLobbyTotal = 0,
      gAlbTotal = 0,
      gStaffTotal = 0,
      gDuchAlbTotal = 0,
      gGymTotal = 0,
      gPiscTotal = 0,
      gCocinaTotal = 0,
      gTrampasTotal = 0,
      gBuffetTotal = 0,
      gLavalozaTotal = 0,
      gLavandTotal = 0,
      gBasuraTotal = 0,
      gACTotal = 0,
      gRegTotal = 0,
      gOtrosTotal = 0;

    if (puntosEq > 0) {
      gHabTotal      = Math.round(ajustado * (puntosHab      / puntosEq));
      gLobbyTotal    = Math.round(ajustado * (puntosLobby    / puntosEq));
      gAlbTotal      = Math.round(ajustado * (puntosAlb      / puntosEq));
      gStaffTotal    = Math.round(ajustado * (puntosStaff    / puntosEq));
      gDuchAlbTotal  = Math.round(ajustado * (puntosDuchAlb  / puntosEq));
      gGymTotal      = Math.round(ajustado * (puntosGym      / puntosEq));
      gPiscTotal     = Math.round(ajustado * (puntosPisc     / puntosEq));
      gCocinaTotal   = Math.round(ajustado * (puntosCocina   / puntosEq));
      gTrampasTotal  = Math.round(ajustado * (puntosTrampas  / puntosEq));
      gBuffetTotal   = Math.round(ajustado * (puntosBuffet   / puntosEq));
      gLavalozaTotal = Math.round(ajustado * (puntosLavaloza / puntosEq));
      gLavandTotal   = Math.round(ajustado * (puntosLavand   / puntosEq));
      gBasuraTotal   = Math.round(ajustado * (puntosBasura   / puntosEq));
      gACTotal       = Math.round(ajustado * (puntosAC       / puntosEq));
      gRegTotal      = Math.round(ajustado * (puntosReg      / puntosEq));

      var sumaAsignada =
        gHabTotal + gLobbyTotal + gAlbTotal + gStaffTotal +
        gDuchAlbTotal + gGymTotal + gPiscTotal + gCocinaTotal +
        gTrampasTotal + gBuffetTotal + gLavalozaTotal + gLavandTotal +
        gBasuraTotal + gACTotal + gRegTotal;

      gOtrosTotal = ajustado - sumaAsignada;
      if (gOtrosTotal < 0) gOtrosTotal = 0;
    }

    // Dosis por evento
    var gHabAplic      = gHabTotal      / appsMes;
    var gLobbyAplic    = gLobbyTotal    / appsMes;
    var gAlbAplic      = gAlbTotal      / appsMes;
    var gStaffAplic    = gStaffTotal    / appsMes;
    var gDuchAlbAplic  = gDuchAlbTotal  / appsMes;
    var gGymAplic      = gGymTotal      / appsMes;
    var gPiscAplic     = gPiscTotal     / appsMes;
    var gCocinaAplic   = gCocinaTotal   / appsMes;
    var gTrampasAplic  = gTrampasTotal  / appsMes;
    var gBuffetAplic   = gBuffetTotal   / appsMes;
    var gLavalozaAplic = gLavalozaTotal / appsMes;
    var gLavandAplic   = gLavandTotal   / appsMes;
    var gBasuraAplic   = gBasuraTotal   / appsMes;
    var gACAplic       = gACTotal       / appsMes;
    var gRegAplic      = gRegTotal      / appsMes;
    var gOtrosAplic    = gOtrosTotal    / appsMes;

    // mL por zona por evento
    var mlHabAplic      = mlZona(gHabAplic);
    var mlLobbyAplic    = mlZona(gLobbyAplic);
    var mlAlbAplic      = mlZona(gAlbAplic);
    var mlStaffAplic    = mlZona(gStaffAplic);
    var mlDuchAlbAplic  = mlZona(gDuchAlbAplic);
    var mlGymAplic      = mlZona(gGymAplic);
    var mlPiscAplic     = mlZona(gPiscAplic);
    var mlCocinaAplic   = mlZona(gCocinaAplic);
    var mlTrampasAplic  = mlZona(gTrampasAplic);
    var mlBuffetAplic   = mlZona(gBuffetAplic);
    var mlLavalozaAplic = mlZona(gLavalozaAplic);
    var mlLavandAplic   = mlZona(gLavandAplic);
    var mlBasuraAplic   = mlZona(gBasuraAplic);
    var mlACAplic       = mlZona(gACAplic);
    var mlRegAplic      = mlZona(gRegAplic);
    var mlOtrosAplic    = mlZona(gOtrosAplic);

    // Por punto
    var ppHab      = calcPorPunto(gHabAplic,      mlHabAplic,      numHab);
    var ppLobby    = calcPorPunto(gLobbyAplic,    mlLobbyAplic,    banosLobby);
    var ppAlb      = calcPorPunto(gAlbAplic,      mlAlbAplic,      banosAlberca);
    var ppStaff    = calcPorPunto(gStaffAplic,    mlStaffAplic,    banosStaff);
    var ppDuchAlb  = calcPorPunto(gDuchAlbAplic,  mlDuchAlbAplic,  duchasAlb);
    var ppGym      = calcPorPunto(gGymAplic,      mlGymAplic,      regGym);
    var ppPisc     = calcPorPunto(gPiscAplic,     mlPiscAplic,     drPiscinas);
    var ppCocina   = calcPorPunto(gCocinaAplic,   mlCocinaAplic,   drCocina);
    var ppTrampas  = calcPorPunto(gTrampasAplic,  mlTrampasAplic,  trampasCocina);
    var ppBuffet   = calcPorPunto(gBuffetAplic,   mlBuffetAplic,   drBuffet);
    var ppLavaloza = calcPorPunto(gLavalozaAplic, mlLavalozaAplic, drLavaloza);
    var ppLavand   = calcPorPunto(gLavandAplic,   mlLavandAplic,   drLavanderia);
    var ppBasura   = calcPorPunto(gBasuraAplic,   mlBasuraAplic,   drBasura);
    var ppAC       = calcPorPunto(gACAplic,       mlACAplic,       drPlantaAC);
    var ppReg      = calcPorPunto(gRegAplic,      mlRegAplic,      regPrinc);
    var ppOtros    = calcPorPunto(gOtrosAplic,    mlOtrosAplic,    otrosDr);

    // -------------------------
    //  SALIDA
    // -------------------------

    var resDiv = container.querySelector('[data-role="resultado"]');

    var html = '';

    html +=
      '<div style="font-size:18px;margin-bottom:4px;">' +
      'Dosis total recomendada para tu hotel: ' +
      '<span style="font-size:24px;font-weight:900;color:#0b3d91;">' +
      formatGrKg(ajustado) +
      '</span> al mes' +
      '</div>';

    html +=
      '<div style="font-size:14px;color:#333;margin-bottom:6px;">' +
      'Programa seleccionado: <strong>' +
      labelPrograma +
      '</strong> &mdash; ' +
      appsMes +
      ' aplicación(es) por mes.' +
      '</div>';

    var sufijoProg =
      programa === 'diaria'
        ? ' (dosis diaria)'
        : programa === 'semanal'
        ? ' (dosis semanal)'
        : programa === 'quincenal'
        ? ' (dosis quincenal)'
        : ' (dosis mensual)';

    html +=
      '<div style="font-size:14px;color:#333;margin-bottom:10px;">' +
      'Dosis total por evento' +
      sufijoProg +
      ': <strong>' +
      formatGrKg(gPorAplicacion) +
      '</strong>. ' +
      (litrosSolAplic > 0
        ? 'Disuélvela en aproximadamente <strong>' +
          litrosSolAplic
            .toFixed(1)
            .replace(/\.0$/, '') +
          ' L</strong> de agua a temperatura ambiente para preparar la <strong>solución madre</strong>. '
        : ''
      ) +
      '<br><span style="font-size:14px;color:#0b3d91;">' +
      '<strong>Nota:</strong> Puedes redondear un poco la dosis para facilitar la medición,' +
      ' pero mantén el orden de magnitud y la frecuencia de aplicación.' +
      '</span>' +
      '</div>';

    // ---- Cómo repartir la dosis ----
    html +=
      '<div style="margin-top:8px;font-size:16px;"><strong>Cómo repartir la dosis en tu hotel:</strong></div>';

    // Habitaciones
    if (numHab > 0 && gHabTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Habitaciones y baños en cuartos de huéspedes</strong>:<br>' +
        '• Dosis mensual para habitaciones: <strong>' +
        formatGrKg(gHabTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gHabAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppHab.g +
        ' g</strong> por habitación, equivalentes a <strong>' +
        formatMl(ppHab.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    // Baños lobby
    if (banosLobby > 0 && gLobbyTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Baños públicos en lobby y áreas comunes</strong>:<br>' +
        '• Dosis mensual para estos baños: <strong>' +
        formatGrKg(gLobbyTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gLobbyAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppLobby.g +
        ' g</strong> por baño, equivalentes a <strong>' +
        formatMl(ppLobby.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    // Baños alberca / playa
    if (banosAlberca > 0 && gAlbTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Baños públicos en zona de alberca / playa</strong>:<br>' +
        '• Dosis mensual para estos baños: <strong>' +
        formatGrKg(gAlbTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gAlbAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppAlb.g +
        ' g</strong> por baño, equivalentes a <strong>' +
        formatMl(ppAlb.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    // Staff
    if (banosStaff > 0 && gStaffTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Baños y vestidores de staff</strong>:<br>' +
        '• Dosis mensual para baños de personal: <strong>' +
        formatGrKg(gStaffTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gStaffAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppStaff.g +
        ' g</strong> por punto, equivalentes a <strong>' +
        formatMl(ppStaff.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    // Alberca / duchas y gym
    if (duchasAlb > 0 && gDuchAlbTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Duchas exteriores en zona de alberca / playa</strong>:<br>' +
        '• Dosis mensual para estas duchas: <strong>' +
        formatGrKg(gDuchAlbTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gDuchAlbAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppDuchAlb.g +
        ' g</strong> por punto, equivalentes a <strong>' +
        formatMl(ppDuchAlb.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    if (regGym > 0 && gGymTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Regaderas en gimnasio y spa</strong>:<br>' +
        '• Dosis mensual para estas áreas: <strong>' +
        formatGrKg(gGymTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gGymAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppGym.g +
        ' g</strong> por regadera, equivalentes a <strong>' +
        formatMl(ppGym.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    if (drPiscinas > 0 && gPiscTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Drenajes de piscinas, jacuzzis y espejos de agua</strong>:<br>' +
        '• Dosis mensual para estos drenajes: <strong>' +
        formatGrKg(gPiscTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gPiscAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppPisc.g +
        ' g</strong> por drenaje, equivalentes a <strong>' +
        formatMl(ppPisc.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    // Cocina
    if ((drCocina > 0 || trampasCocina > 0 || drBuffet > 0 || drLavaloza > 0) &&
        (gCocinaTotal + gTrampasTotal + gBuffetTotal + gLavalozaTotal) > 0) {

      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Cocinas, trampas de grasa, buffets y lavaloza</strong>:<br>';

      if (drCocina > 0 && gCocinaTotal > 0) {
        html +=
          '• <em>Cocina principal</em> — dosis mensual: <strong>' +
          formatGrKg(gCocinaTotal) +
          '</strong>. Por evento: <strong>' +
          formatGrKg(gCocinaAplic) +
          '</strong>, ≈ <strong>' +
          ppCocina.g +
          ' g</strong> por drenaje, equivalentes a <strong>' +
          formatMl(ppCocina.ml) +
          '</strong> de solución madre por punto.<br>';
      }
      if (trampasCocina > 0 && gTrampasTotal > 0) {
        html +=
          '• <em>Trampas de grasa de cocina</em> — dosis mensual: <strong>' +
          formatGrKg(gTrampasTotal) +
          '</strong>. Por evento: <strong>' +
          formatGrKg(gTrampasAplic) +
          '</strong>, ≈ <strong>' +
          ppTrampas.g +
          ' g</strong> por trampa, equivalentes a <strong>' +
          formatMl(ppTrampas.ml) +
          '</strong> de solución madre por punto.<br>';
      }
      if (drBuffet > 0 && gBuffetTotal > 0) {
        html +=
          '• <em>Buffet, snack bar y bares húmedos</em> — dosis mensual: <strong>' +
          formatGrKg(gBuffetTotal) +
          '</strong>. Por evento: <strong>' +
          formatGrKg(gBuffetAplic) +
          '</strong>, ≈ <strong>' +
          ppBuffet.g +
          ' g</strong> por punto, equivalentes a <strong>' +
          formatMl(ppBuffet.ml) +
          '</strong> de solución madre por punto.<br>';
      }
      if (drLavaloza > 0 && gLavalozaTotal > 0) {
        html +=
          '• <em>Lavaloza / túneles de lavado de loza</em> — dosis mensual: <strong>' +
          formatGrKg(gLavalozaTotal) +
          '</strong>. Por evento: <strong>' +
          formatGrKg(gLavalozaAplic) +
          '</strong>, ≈ <strong>' +
          ppLavaloza.g +
          ' g</strong> por drenaje, equivalentes a <strong>' +
          formatMl(ppLavaloza.ml) +
          '</strong> de solución madre por punto.<br>';
      }

      html += '</div>';
    }

    // Lavandería
    if (drLavanderia > 0 && gLavandTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Lavandería interna</strong>:<br>' +
        '• Dosis mensual para lavandería: <strong>' +
        formatGrKg(gLavandTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gLavandAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppLavand.g +
        ' g</strong> por drenaje, equivalentes a <strong>' +
        formatMl(ppLavand.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    // Basura / compactadoras
    if (drBasura > 0 && gBasuraTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Cuartos de basura y compactadoras</strong>:<br>' +
        '• Dosis mensual para estas áreas: <strong>' +
        formatGrKg(gBasuraTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gBasuraAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppBasura.g +
        ' g</strong> por punto, equivalentes a <strong>' +
        formatMl(ppBasura.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    // Planta de A/C
    if (drPlantaAC > 0 && gACTotal > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Cuartos de máquinas y planta de aire acondicionado</strong>:<br>' +
        '• Dosis mensual para estos drenajes: <strong>' +
        formatGrKg(gACTotal) +
        '</strong>.<br>' +
        '• Por evento: <strong>' +
        formatGrKg(gACAplic) +
        '</strong> &mdash; Aproximadamente <strong>' +
        ppAC.g +
        ' g</strong> por punto, equivalentes a <strong>' +
        formatMl(ppAC.ml) +
        '</strong> de solución madre por punto.' +
        '</div>';
    }

    // Registros y PTAR
    if ((regPrinc > 0 || otrosDr > 0) && (gRegTotal + gOtrosTotal) > 0) {
      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>Registros sanitarios principales, fosa y puntos hacia PTAR</strong>:<br>';

      if (regPrinc > 0 && gRegTotal > 0) {
        html +=
          '• Dosis mensual para registros principales: <strong>' +
          formatGrKg(gRegTotal) +
          '</strong>. Por evento: <strong>' +
          formatGrKg(gRegAplic) +
          '</strong>, ≈ <strong>' +
          ppReg.g +
          ' g</strong> por registro, equivalentes a <strong>' +
          formatMl(ppReg.ml) +
          '</strong> de solución madre por punto.<br>';
      }

      if (otrosDr > 0 && gOtrosTotal > 0) {
        html +=
          '• Otros drenajes especiales (laboratorio, áreas técnicas, etc.) — dosis mensual: <strong>' +
          formatGrKg(gOtrosTotal) +
          '</strong>. Por evento: <strong>' +
          formatGrKg(gOtrosAplic) +
          '</strong>, ≈ <strong>' +
          ppOtros.g +
          ' g</strong> por punto, equivalentes a <strong>' +
          formatMl(ppOtros.ml) +
          '</strong> de solución madre por punto.<br>';
      }

      html += '</div>';
    }

    // Nota general de aplicación
    html +=
      '<div style="margin-top:10px;color:#444;font-size:14px;">' +
      'Aplica preferentemente al final del turno o en horarios de menor uso de baños, albercas y cocinas, ' +
      'cuando hay menos agua de lavado y menos químicos en las líneas. Evita usar cloro, sosa cáustica o ' +
      'desengrasantes muy agresivos al menos <strong>6–12 horas antes y después</strong> de aplicar BACTER spp., ' +
      'para no afectar la actividad biológica.' +
      '</div>';

    // Bloque DBO / DQO referencial
    html +=
      '<div style="margin-top:14px;font-size:14px;color:#0b3d91;">' +
      '<strong>Comportamiento esperado en DBO / DQO (dato referencial)</strong><br>';

    if (dbo > 0 || dqo > 0) {
      var dboObjetivo =
        dbo > 0 ? Math.round(dbo * 0.5) : null;
      var dqoObjetivo =
        dqo > 0 ? Math.round(dqo * 0.5) : null;

      html += 'Si actualmente tienes valores cercanos a ';

      if (dbo > 0) {
        html +=
          'DBO ≈ <strong>' +
          Math.round(dbo) +
          ' mg/L</strong>';
      }
      if (dbo > 0 && dqo > 0) {
        html += ' y ';
      }
      if (dqo > 0) {
        html +=
          'DQO ≈ <strong>' +
          Math.round(dqo) +
          ' mg/L</strong>';
      }

      html +=
        ', aplicando BACTER spp. de forma continua según este programa ' +
        'y manteniendo buenas prácticas de higiene en habitaciones, cocinas y áreas de servicios, ' +
        'es razonable esperar reducciones importantes en <strong>2 a 3 meses</strong>, ' +
        'acercándote a valores alrededor de ';

      if (dboObjetivo) {
        html +=
          'DBO ≈ <strong>' + dboObjetivo + ' mg/L</strong>';
      }
      if (dboObjetivo && dqoObjetivo) {
        html += ' y ';
      }
      if (dqoObjetivo) {
        html +=
          'DQO ≈ <strong>' + dqoObjetivo + ' mg/L</strong>';
      }

      html += '. ';
    } else {
      html +=
        'En hoteles donde se dosifica de forma constante bajo un programa <strong>' +
        labelPrograma +
        '</strong>, suele observarse una disminución progresiva de DBO y DQO en un periodo de ' +
        '<strong>1 a 3 meses</strong>, siempre que se mantengan buenas prácticas de operación y se controlen ' +
        'los vertidos de químicos agresivos.';      
    }

    html +=
      ' Este cálculo es <strong>solo orientativo</strong>. El cumplimiento con la NOM aplicable ' +
      'y con tu autoridad local siempre debe verificarse mediante muestreos de laboratorio y la interpretación ' +
      'de tu responsable sanitario o asesor ambiental.' +
      '</div>';

    resDiv.innerHTML = html;
    resDiv.style.display = 'block';
  }

  // -------------------------
  //  INICIALIZACIÓN
  // -------------------------

  function init() {
    var widgets = qsa('.bacter-widget[data-scenario="hoteleria"]');
    if (!widgets.length) return;

    widgets.forEach(function (elWidget) {
      try {
        var cfg = {
          scenario: elWidget.getAttribute('data-scenario') || 'hoteleria',
          title: elWidget.getAttribute('data-title') || null,
          defaults: {
            tipo_hotel:
              elWidget.getAttribute('data-default-tipo-hotel') ||
              'hostal_posada',
            programa:
              elWidget.getAttribute('data-default-programa') || 'semanal',

            num_habitaciones: parseInt(
              elWidget.getAttribute('data-default-num-habitaciones') ||
                BASE_HABITACIONES,
              10
            ),
            ocupacion_pct: parseFloat(
              elWidget.getAttribute('data-default-ocupacion-porcentaje') ||
                BASE_OCUPACION_PCT
            ),
            huespedes_por_hab: parseFloat(
              elWidget.getAttribute('data-default-huespedes-por-habitacion') ||
                BASE_HUESPEDES_HAB
            ),

            caudal_litros_dia: parseFloat(
              elWidget.getAttribute('data-default-caudal') ||
                BASE_CAUDAL_L_DIA
            ),
            dbo_inicial: parseFloat(
              elWidget.getAttribute('data-default-dbo') || BASE_DBO
            ),
            dqo_inicial: parseFloat(
              elWidget.getAttribute('data-default-dqo') || BASE_DQO
            ),

            tiene_ptar:
              elWidget.getAttribute('data-default-tiene-ptar') === 'true',
            caudal_ptar_m3_dia: parseFloat(
              elWidget.getAttribute('data-default-caudal-ptar-m3-dia') || 0
            ),

            banos_publicos_lobby: parseInt(
              elWidget.getAttribute('data-default-banos-publicos-lobby') || 0,
              10
            ),
            banos_publicos_alberca: parseInt(
              elWidget.getAttribute('data-default-banos-publicos-alberca') ||
                0,
              10
            ),
            banos_staff: parseInt(
              elWidget.getAttribute('data-default-banos-staff') || 0,
              10
            ),

            duchas_alberca_playa: parseInt(
              elWidget.getAttribute('data-default-duchas-alberca-playa') || 0,
              10
            ),
            regaderas_gym_spa: parseInt(
              elWidget.getAttribute('data-default-regaderas-gym-spa') || 0,
              10
            ),
            drenajes_piscinas_jacuzzis: parseInt(
              elWidget.getAttribute(
                'data-default-drenajes-piscinas-jacuzzis'
              ) || 0,
              10
            ),

            drenajes_cocina_principal: parseInt(
              elWidget.getAttribute(
                'data-default-drenajes-cocina-principal'
              ) || 0,
              10
            ),
            trampas_grasa_cocina: parseInt(
              elWidget.getAttribute(
                'data-default-trampas-grasa-cocina'
              ) || 0,
              10
            ),
            drenajes_buffet_snack: parseInt(
              elWidget.getAttribute('data-default-drenajes-buffet-snack') || 0,
              10
            ),
            drenajes_lavaloza: parseInt(
              elWidget.getAttribute('data-default-drenajes-lavaloza') || 0,
              10
            ),

            drenajes_lavanderia: parseInt(
              elWidget.getAttribute('data-default-drenajes-lavanderia') || 0,
              10
            ),
            drenajes_cuartos_basura: parseInt(
              elWidget.getAttribute('data-default-drenajes-cuartos-basura') ||
                0,
              10
            ),
            drenajes_planta_ac: parseInt(
              elWidget.getAttribute('data-default-drenajes-planta-ac') || 0,
              10
            ),
            registros_principales: parseInt(
              elWidget.getAttribute('data-default-registro-principal') || 0,
              10
            ),
            otros_drenajes: parseInt(
              elWidget.getAttribute('data-default-otros-drenajes') || 0,
              10
            ),

            carga: elWidget.getAttribute('data-default-carga') || 'baja',
            modo:
              elWidget.getAttribute('data-default-modo') ||
              'mantenimiento',
            quimicos:
              elWidget.getAttribute('data-default-quimicos') === 'true'
          }
        };

        renderWidget(elWidget, cfg);
      } catch (err) {
        console.error('bacter-hoteleria init error', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
